import { ItemDetailStatusEnum } from "../entities/entity-model";

export const ItemDetailStatusCodes = {
  Addon: [
    ItemDetailStatusEnum.InProcessAddon, 
    ItemDetailStatusEnum.InProcessPendingAddon
  ],
  ShipPrep: [
    ItemDetailStatusEnum.InProcessPendingShipPrep,
    ItemDetailStatusEnum.InProcessShipPrep,
    ItemDetailStatusEnum.InProcessShipHeld,
  ],
  InProcess: [
    ItemDetailStatusEnum.InProcessAddon, 
    ItemDetailStatusEnum.InProcessPendingAddon,
    ItemDetailStatusEnum.InProcessPendingShipPrep,
    ItemDetailStatusEnum.InProcessShipPrep,
    ItemDetailStatusEnum.InProcessShipHeld,
    ItemDetailStatusEnum.InProcessVoucher,
  ]
}